exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SettingsModal-module__modalContent2___3buQ2 .SettingsModal-module__image-wrapper___3LwSk{max-width:200px;display:flex;justify-content:center;margin:0 auto 1rem}.SettingsModal-module__modalContent2___3buQ2 h1,.SettingsModal-module__modalContent2___3buQ2 p{margin-bottom:1rem}.SettingsModal-module__modalContent2___3buQ2 a{color:#0827e9;cursor:pointer}.SettingsModal-module__modalContent2___3buQ2 .SettingsModal-module__inactive___cj2qE{opacity:.5;cursor:default!important}.SettingsModal-module__modalContent2___3buQ2 .SettingsModal-module__buttons-wrapper___PEjIZ{margin-top:2rem;display:grid;grid-auto-flow:column;gap:.5rem;justify-content:end}", ""]);

// exports
exports.locals = {
	"modalContent2": "SettingsModal-module__modalContent2___3buQ2",
	"image-wrapper": "SettingsModal-module__image-wrapper___3LwSk",
	"inactive": "SettingsModal-module__inactive___cj2qE",
	"buttons-wrapper": "SettingsModal-module__buttons-wrapper___PEjIZ"
};